module.exports = __webpack_public_path__ + "static/media/breakdownTable2.444bd706.png";